import type {
	SRT_Header,
	SRT_RowData,
	SRT_TableInstance,
	TableRowProps,
} from '../../types'

import { TableRow } from '@/shared/components/ui/table'

import { SRT_TableHeadCell } from './SRT_TableHeadCell'

export type SRT_TableHeadRowProps<TData extends SRT_RowData> = {
	headers: {
		header: SRT_Header<TData>
		isPinned: boolean | 'left' | 'right'
		left: number
		right: number
	}[]
	table: SRT_TableInstance<TData>
} & TableRowProps

export const SRT_TableHeadRow = <TData extends SRT_RowData>({
	headers,
	table,
}: SRT_TableHeadRowProps<TData>) => (
	<TableRow>
		{headers.map(({ header, isPinned, left, right }, index) =>
			header ? (
				<SRT_TableHeadCell
					header={header}
					key={header.id}
					staticColumnIndex={index}
					options={{ isPinned, left, right }}
					table={table}
				/>
			) : null
		)}
	</TableRow>
)
